import { hexColors } from '@mobi/settings'

/** @deprecated Please DO NOT use this object, other options:
 * - Use generic mobi { colors } from '@mobi/settings' (ONLY generic high level, ie. brandPrimary etc)
 * - Use local `colors.ts` or `themes.ts` files
 * - Use { hexColors } from '@mobi/settings'
 *
 * This object does not follow the co-location principle, making maintenance difficult.
 */
export const colors = {
  nextEvents: {
    distance: {
      text: hexColors.dimGrey,
    },
    toggle: {
      background: hexColors.gainsboro,
      text: hexColors.white,
      selected: {
        text: hexColors.white,
        background: hexColors.chocolate,
      },
      unselected: {
        text: hexColors.darkGrey,
        background: hexColors.white,
        border: hexColors.veryLightGrey,
      },
    },
    jackpot: {
      text: hexColors.orange,
    },
  },

  quickbet: {
    investment: {
      background: 'rgba(255,255,255,0.12)',
      text: hexColors.white,
      active: {
        background: hexColors.white,
        text: hexColors.blueDiamond,
      },
      legInfo: {
        text: hexColors.blueDiamond,
        background: 'transparent',
        boosted: {
          background: hexColors.orange,
          text: hexColors.black,
        },
      },
    },
  },

  priceChange: {
    increase: {
      text: hexColors.sushi,
    },
    decrease: {
      text: hexColors.cinnabar,
    },
    none: {
      text: hexColors.white,
      active: {
        text: hexColors.blueDiamond,
      },
    },
  },

  messages: {
    error: {
      text: hexColors.freeSpeechRed,
      background: '#f9e5e5',
      border: '#f4cccc',
    },
    success: {
      text: hexColors.sushi,
      background: '#eff5eb',
      border: '#e0ebd7',
    },
    info: {
      text: hexColors.summerSky,
      background: '#edf4fb',
      border: '#dbe9f8',
    },
    warning: {
      text: hexColors.chocolate,
      background: '#fbf0e7',
      border: '#f8e1d0',
    },
  },

  password: {
    light: {
      label: {
        text: hexColors.dimGrey,
      },
      input: {
        background: hexColors.white,
      },
      rules: {
        text: hexColors.dimGrey,
      },
      icon: {
        text: hexColors.black,
      },
    },
    dark: {
      label: {
        text: hexColors.white,
        background: hexColors.blueDiamond,
      },
      input: {
        background: hexColors.gainsboro,
      },
      rules: {
        text: hexColors.white,
      },
      icon: {
        text: hexColors.black,
        background: 'transparent',
      },
    },
  },

  raceList: {
    fixtureStatus: {
      textDark: hexColors.black,
      textLight: hexColors.white,
    },
    quaddieChip: {
      background: hexColors.crimson,
      text: hexColors.white,
    },
    results: {
      text: hexColors.cinnabar,
    },
    class: {
      text: hexColors.dimGrey,
    },
    jackpot: {
      text: hexColors.orange,
    },
    specials: {
      text: hexColors.orange,
    },
  },

  fixedFlucs: {
    separator: hexColors.whiteSmoke,
    dividends: {
      separator: hexColors.veryLightGrey,
    },
    label: hexColors.dimGrey,
  },

  starters: {
    buttonSelection: {
      default: {
        background: `linear-gradient(to bottom, ${hexColors.white}, ${hexColors.whiteSmoke})`,
        color: hexColors.nero,
        secondary: hexColors.grey,
        borderColor: hexColors.veryLightGrey,
      },
      selected: {
        background: hexColors.nero,
        color: hexColors.white,
        borderColor: hexColors.nero,
      },
      disabled: {
        background: hexColors.gainsboro,
        color: hexColors.grey,
      },
      priceChange: {
        background: hexColors.infoBlueLight,
        arrow: {
          borderColor: hexColors.infoBlueDark,
        },
        selected: {
          background: hexColors.infoBlueDark,
        },
      },
    },
  },
} as const
